class ComponentQuestion {
  constructor() {
    this._init();
  }

  _init() {
    const questions = document.querySelectorAll('[data-question]');

    questions.forEach(function (question) {
      question.addEventListener(
        'click',
        function () {
          question.classList.toggle(
            'open'
          );
        },
        false
      );
    });
  }
}

export const componentQuestion = new ComponentQuestion();
